module.exports = __webpack_public_path__ + "img/liket.257271d6.png";